/**
 * @generated SignedSource<<db0d7b4449c82f1fa2c4eacf90feb219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarContainer_project$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingEntrypointProvider_project">;
  readonly " $fragmentType": "ConditionalFormattingSidebarContainer_project";
};
export type ConditionalFormattingSidebarContainer_project$key = {
  readonly " $data"?: ConditionalFormattingSidebarContainer_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarContainer_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarContainer_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ConditionalFormattingEntrypointProvider_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "122bf496388bea23293bf790ee51265a";

export default node;
